import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import companyReducer from '../../common/redux/features/company/companySlice'
import entitlementsReducer from '../../common/redux/features/entitlements/entitlementsSlice'
import portalSessionResetReducer from '../../common/redux/features/portal-session-reset/portalSessionResetSlice'
import { enhancedApi as webApi } from '../../common/redux/api/enhancedWebApi'
import userReducer, { reset } from '../../common/redux/features/user/userSlice'

import { chargePointApi } from './api/chargePointsApi'
import chargePointsReducer from './features/chargePoints/chargePointsSlice'
import scopedAccessSessionReducer from './features/scopedAccessSession/scopedAccessSessionSlice'
import selectedUserReducer from './features/selectedUser/selectedUserSlice'

const createRootReducers = () => {
    const rootReducerFn = combineReducers({
        chargePoints: chargePointsReducer,
        company: companyReducer,
        entitlements: entitlementsReducer,
        portalSessionReset: portalSessionResetReducer,
        scopedAccessSession: scopedAccessSessionReducer,
        user: userReducer,
        selectedUser: selectedUserReducer,
        [chargePointApi.reducerPath]: chargePointApi.reducer,
        [webApi.reducerPath]: webApi.reducer,
    })

    return (state: Parameters<typeof rootReducerFn>[0], action: Parameters<typeof rootReducerFn>[1]) => {
        return rootReducerFn(reset && action.type === reset.type ? undefined : state, action)
    }
}

export const store = configureStore({
    reducer: createRootReducers(),
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([chargePointApi.middleware, webApi.middleware]),
})

export const preloadedStoreFactory = (preloadedState?: any) => {
    return configureStore({
        reducer: createRootReducers(),
        devTools: process.env.NODE_ENV === 'development',
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat([chargePointApi.middleware, webApi.middleware]),
        preloadedState: preloadedState,
    })
}

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
